<div class="margin pt-20 pr-20 pl-20" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign.gt-sm="center center" fxLayoutAlign="center center">
  <div class="" fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="50">
    <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
    <h4 class="mt-0 mb-10 midText">Progreso actual: 69%</h4>
  </div>
</div>
